import React, { useCallback } from 'react';
import { useForm } from 'react-final-form';

import AddMoreButton from '../../../AddMoreButton/AddMoreButton';
import { changeArray } from '../../utils';

type Props = {
  label: string;
};

export default function WorkspaceAddMoreButton({ label }: Props) {
  const {
    mutators: { push },
  } = useForm();

  const handleClick = useCallback(() => changeArray(1, push, 'workspaces'), [push]);

  return <AddMoreButton className="mt-2" label={label} action={handleClick} />;
}
